<template>
  <div @mouseleave="onMouseLeave" @mouseover="onMouseOver">
    <clouded-glass class="content">
      <div slot="content">
        <div class="text-lightBlue font-weight-bold" style="position: relative">
          {{ item.name }}
          <i v-show="showBtn"
             ref="btnEdit"
             class="el-icon-copy-document text-blue pointer"
             @touchstart="editProcess(item,true)"
             @click="editProcess(item,true)"
             style="position: absolute;right: 40px;top: 5px"></i>
          <i v-show="showBtn"
             ref="btnEdit"
             class="el-icon-edit text-blue pointer"
             @touchstart="editProcess(item,false)"
             @click="editProcess(item,false)"
             style="position: absolute;right: 20px;top: 5px"></i>
          <i v-show="showBtn"
             ref="btnDelete"
             @touchstart="deleteProcess"
             @click="deleteProcess"
             class="el-icon-close text-red font-weight-bold pointer"
             style="position: absolute;right: 0;top: 5px"></i>
        </div>
        <div style="display:flex;margin: 10px 0 10px 10px;align-items: center">
          <div style="flex-basis: 100px;padding-right:10px;border-right: 1px dashed rgba(255,255,255,.2)">
            <name-icon :title="'v'+item.version" :height="'60px'" :width="'60px'" :lineHeight="'60px'"></name-icon>
            <div class="text-center margin-top-10" style="font-size: 0.9rem">{{ lastUpdatedTime }}</div>
            <div class="text-center margin-top-10" style="font-size: 0.9rem">
              <span class="text-green" v-if="item.deploy">已发布</span>
              <span class="text-grey" v-else>未发布</span>
            </div>
          </div>
          <div style="width: calc(100% - 90px)" class="text-center">
              <div v-if="false" class="text-grey" >
                暂无缩略图
              </div>
              <img :src="thumbnailUrl(item.id)" style="max-width: 200px;max-height: 120px" v-else>
          </div>
        </div>
      </div>
    </clouded-glass>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import NameIcon from "@/components/style/NameIcon";
import {deleteProcessByPid} from "@/network/activiti";
import {dateFormat} from "@/network/alarm-realtime";
import {serviceUrl} from "@/utils/request";
export default {
  name: "ProcessItem",
  props: ["item"],
  components: {NameIcon, CloudedGlass},
  data() {
    return {
      showBtn: false,
      enable: false,
      lastUpdatedTime:'',
    }
  },
  mounted() {
    this.lastUpdatedTime=this.item.lastUpdatedTime?dateFormat(this.item.lastUpdatedTime,"yyyy-MM-dd"):'-';
  },
  methods: {
    thumbnailUrl(id){
      return `${window.g.gatewayUrl}${serviceUrl.activitiService.substring(1)}/act/de/model/thumbnail/${id}`
    },
    onMouseOver() {
      this.showBtn = true
    },
    onMouseLeave() {
      this.showBtn = false
    },
    editProcess(data,copy){
      this.$emit('editProcess',data,copy)
    },
    // 删除流程
    deleteProcess() {
      this.$confirm('是否确认删除流程：' + this.item.name, {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            let list=[];
            list.push(this.item.id)
            // 删除
            deleteProcessByPid(list).then(res => {
              if (res.code === 0) {
                this.$message.success('删除成功');
                // 刷新列表
                this.$emit('getActList');
              } else {
                this.item.isEnable = !this.item.isEnable;
                this.$message.error('删除失败');
              }
            });
            // 刷新
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.content {
  width: 380px;
  height: 200px;
  padding: 20px 25px 20px 25px;
}

.hidden.btn {
  flex: inherit;
}

.hidden.btn:hover {
  cursor: pointer;
}

.btn-edit {
  margin: 0 0 0 37px;
}

.btn-delete {
  margin: 0 0 0 115px;
}

/*图标*/
.logo.img {
  margin: 50px 0 0 103px;
  width: 58px;
  height: 50px;
}
</style>
